import { ref as l, computed as W, onMounted as k, useCssModule as V, openBlock as b, createElementBlock as B, normalizeClass as m, createElementVNode as u, normalizeStyle as M, unref as N, renderSlot as w } from "vue";
const A = "_marqueeSlider_1htck_3", I = "_marqueeSliderContainer_1htck_11", x = "_horizontalAnimation_1htck_1", z = "_marqueeSliderContainerVertical_1htck_27", E = "_verticalAnimation_1htck_1", F = {
  marqueeSlider: A,
  marqueeSliderContainer: I,
  horizontalAnimation: x,
  marqueeSliderContainerVertical: z,
  verticalAnimation: E
}, j = (i, t) => {
  const r = i.__vccOpts || i;
  for (const [s, n] of t)
    r[s] = n;
  return r;
}, L = ["id"], O = /* @__PURE__ */ u("div", null, "Hello", -1), R = /* @__PURE__ */ u("div", null, "From", -1), H = /* @__PURE__ */ u("div", null, "MarqueeSlider", -1), D = {
  __name: "VueMarqueeSlider",
  props: {
    autoWidth: {
      type: Boolean,
      default: () => !1
    },
    height: {
      type: Number,
      default: () => 200
    },
    id: {
      type: String,
      required: !0,
      default: () => "id"
    },
    paused: {
      type: Boolean,
      default: () => !1
    },
    repeat: {
      type: Number,
      default: () => 10
    },
    reverse: {
      type: Boolean,
      default: () => !1
    },
    space: {
      type: Number,
      default: () => 200
    },
    speed: {
      type: Number,
      default: () => 1500
    },
    vertical: {
      type: Boolean,
      default: () => !1
    },
    width: {
      type: Number,
      default: () => 100
    }
  },
  setup(i) {
    const t = i;
    var r = l(null), s = l(0), n = l([]), o = l(0), c = l([]), d = l(null);
    const h = W(
      () => `
      animation-duration: ${t.speed}ms;
      animation-direction: ${t.reverse ? "reverse" : "normal"};
      animation-play-state: ${t.paused ? "paused" : "running"};
      height: ${t.vertical ? t.height : "auto"}
    `
    );
    k(() => {
      d = V(), $(), v(), _(), p(), g(), f();
    });
    function p() {
      for (let e = 0; e < o; e++)
        c.value.push(n[e].offsetWidth), S(e), t.autoWidth ? C(e) : q(e);
      s = c.value.reduce((e, a) => e + a, 0);
    }
    function f() {
      const e = y();
      for (let a = 0; a < e; a++)
        r.appendChild(n[a].cloneNode(!0));
    }
    function y() {
      return n.length * t.repeat;
    }
    function v() {
      n = r.children;
    }
    function _() {
      o = n.length;
    }
    function S(e) {
      t.vertical ? n[e].style.marginBottom = `${t.space}px` : n[e].style.marginRight = `${t.space}px`;
    }
    function q(e) {
      n[e].style.minWidth = `${t.width}px`;
    }
    function C(e) {
      n[e].style.objectFit = "contain";
    }
    function $() {
      r = document.querySelector(
        `#${t.id} .${t.vertical ? d.marqueeSliderContainerVertical : d.marqueeSliderContainer}`
      );
    }
    function g() {
      t.vertical ? r.style.width = "auto" : t.autoWidth ? r.style.width = `${o * (s / o + t.space)}px` : r.style.width = `${o * (t.width + t.space)}px`;
    }
    return (e, a) => (b(), B("div", {
      id: i.id,
      class: m(e.$style.marqueeSlider)
    }, [
      u("div", {
        class: m(i.vertical ? e.$style.marqueeSliderContainerVertical : e.$style.marqueeSliderContainer),
        style: M(N(h))
      }, [
        w(e.$slots, "default", {}, () => [
          O,
          R,
          H
        ])
      ], 6)
    ], 10, L));
  }
}, G = {
  $style: F
}, K = /* @__PURE__ */ j(D, [["__cssModules", G]]);
export {
  K as VueMarqueeSlider
};
